import React from 'react';
import PropTypes from 'prop-types';

const Galaxy = props => {
  return (
    <svg
      width="590"
      height="590"
      viewBox="0 0 590 590"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill={props.color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-1.28728e-05 295.505C28.9469 453.25 187.675 569.072 337.431 498.177C428.28 454.246 481.198 326.46 402.332 257.571C396.34 251.578 390.347 247.591 382.373 243.603C509.154 353.43 325.47 578.069 136.783 453.255C12.999 370.394 4.00731 204.648 86.8626 86.8435C-4.97791 218.638 24.9591 412.317 181.7 468.237C276.538 502.188 404.334 448.276 398.345 344.443C397.354 336.445 395.349 328.47 392.353 320.472C405.328 488.201 115.811 517.149 70.8935 294.519C41.9465 148.758 153.748 24.9593 294.518 -8.36743e-06C136.785 28.9492 20.973 187.69 91.8623 337.458C135.79 428.314 263.566 481.236 332.449 403.355C338.442 396.371 342.429 390.378 346.416 382.38C236.598 509.171 11.9765 325.472 136.781 136.77C219.635 12.977 385.368 3.98461 503.163 86.8464C371.379 -5.00131 177.715 24.9381 121.8 181.692C87.852 276.537 141.759 404.343 245.584 398.353C253.581 397.362 261.555 395.357 269.553 392.361C101.838 405.337 72.8918 115.797 295.504 71.8674C441.253 41.9269 565.043 153.737 590 295.509C561.053 136.773 402.325 20.9516 252.569 91.823C161.72 135.754 108.802 263.54 186.677 332.429C193.66 338.422 199.652 342.409 207.65 346.397C80.8693 236.57 264.553 11.9309 453.24 136.745C577.024 219.606 586.016 386.344 503.16 503.156C595.001 371.362 565.064 177.683 408.323 121.763C313.485 87.8124 185.689 141.724 191.678 245.557C192.669 254.546 194.674 261.529 197.67 269.528C184.695 101.799 474.212 72.8509 518.138 295.481C548.076 441.242 436.275 565.041 294.514 590C453.238 561.051 569.05 402.31 498.184 253.534C454.256 161.686 325.471 108.764 257.597 187.637C251.605 193.629 247.618 199.622 243.63 207.597C353.448 80.8061 578.07 264.505 453.266 453.207C370.411 577 203.687 585.992 86.8833 503.131C218.667 594.978 412.331 565.039 468.246 408.285C502.195 313.44 448.287 185.634 344.463 192.638C336.465 192.638 328.491 194.644 320.494 197.64C488.209 184.664 517.155 474.204 294.543 518.134C148.793 548.074 25.0039 436.264 0.0465977 295.483L-1.28728e-05 295.505Z"
      />
    </svg>
  );
};

Galaxy.defaultProps = {
  color: '#9B4CEE',
};

Galaxy.propTypes = {
  color: PropTypes.string,
};

export default Galaxy;
